import { baseURLAdmin, commonHeaderAdmin } from "api/constants";

export async function getPermissionAPI(params = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (params.projectId) queryParams.append("projectId", params.projectId);
    if (params.datasetId) queryParams.append("datasetId", params.datasetId);
    if (params.sourceId) queryParams.append("sourceId", params.sourceId);
    const queryString = queryParams.toString();
    const url = `${baseURLAdmin}/users/permissions${
      queryString ? `?${queryString}` : ""
    }`;
    const res = await fetch(url, {
      method: "GET",
      ...commonHeaderAdmin,
    });
    return await res.json();
  } catch (error) {
    console.log(error, "error");
    return { error: true, ...error };
  }
}
